import { render, staticRenderFns } from "./ManagerNews.vue?vue&type=template&id=1bb45ad2&"
import script from "./ManagerNews.vue?vue&type=script&lang=js&"
export * from "./ManagerNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports